// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab4f8611","239":"1a5efe6e","667":"07c17a34"}[chunkId] + ".chunk.js";
};